module.exports = __webpack_public_path__ + "img/logo-sticky.503dfc94.png";